import { cn } from 'cn';
import { useId } from 'react';

import { type UUID } from '~/types/common';

import { isFieldRequired, unique } from '@vestigas/utils';

import { ValidationError } from '@vestigas/ui/molecules';

import { MultiSelectDeliveryNotes } from '../SelectServerDriven/MultiSelectDeliveryNotes';

import { useFieldContext } from './form-context';
import { InputLabel } from './InputLabel';

type P = {
  readonly classNameErrors?: string;
  readonly hint?: string;
  readonly isDisabled?: boolean;
  readonly label?: string;
  readonly placeholder?: string;
} & ComponentStyling;

export const MultiSelectDeliveryNotesField = ({
  className,
  classNameErrors,
  hint,
  isDisabled = false,
  label,
  placeholder,
  style,
}: P) => {
  const field = useFieldContext<UUID[]>();

  const isRequired = isFieldRequired(
    field.options.form.options.validators,
    field.name,
  );

  const errorMessages = unique(
    (field.state.meta.errors as { message: string }[]).map(
      ({ message }) => message,
    ),
  ).join(', ');
  const hasErrors = Boolean(errorMessages);

  const id = useId();

  return (
    <div className={cn('relative', className)} style={style}>
      {Boolean(label) && (
        <InputLabel hint={hint} htmlFor={id} isRequired={isRequired}>
          {label}
        </InputLabel>
      )}
      <MultiSelectDeliveryNotes
        isDisabled={isDisabled}
        placeholder={placeholder}
        value={field.state.value}
        onChange={(assetIds) => {
          field.handleChange(assetIds);
        }}
      />
      {hasErrors ? (
        <ValidationError className={classNameErrors}>
          {errorMessages}
        </ValidationError>
      ) : null}
    </div>
  );
};
